import React from 'react';
import './clases.css'
import { Fade } from "react-awesome-reveal";


function Clases() {
    return (
    <section className="clasescontainer" id="clasescontainer">
        <div className="clasestexto">
            <Fade bottom delay={100} duration={1000}  fraction={0.2}><h2>PÄDAGOGIK</h2></Fade>
            <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                <p>Amy ist seit mehr als fünfzehn Jahren als Instrumentallehrerin tätig und hat in den unterschiedlichsten
Kontexten unterrichtet, darunter viele Jahre im Nationalen Programm für Kinder- und Jugendorchester
des Ministeriums für Bildung der Nation Argentinien. Dort arbeitete sie als Violinlehrerin und
Ausbilderin von Lehrkräften mit einem besonderen Fokus auf Gruppenarbeit.Ihre Lehrerfahrung
umfasst ein breites Publikum, von Kindern bis zu Erwachsenen.</p>
                <p>In ihren Unterrichtsstunden behandelt
sie sowohl die spezifische Technik des Instruments als auch allgemeine musikalische Elemente wie
Improvisation und Komposition.</p>
                        
            </Fade>
        </div>
        <div className="clasesspotify">
            <Fade>
                <iframe className='stliframe' src="https://open.spotify.com/embed/artist/3AGGyNDwL2K76SPArpC4QN?utm_source=generator&theme=0" title="Spotify media player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" loading="lazy"></iframe>
            </Fade>
        </div>
    </section>
)
}

export default Clases